import { render, staticRenderFns } from "./dataForms.vue?vue&type=template&id=3a439731&"
import script from "./dataForms.vue?vue&type=script&lang=js&"
export * from "./dataForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports